var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkExpiry(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.807,
    height: 51.215,
    viewBox: "0 0 57.807 51.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_45820",
    "data-name": "Group 45820",
    transform: "translate(-647 -195)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2010",
    "data-name": "Group 2010",
    transform: "translate(616.592 163.182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_948",
    "data-name": "Path 948",
    d: "M141.72,294.495a24.513,24.513,0,1,1-24.513-24.513A24.513,24.513,0,0,1,141.72,294.495Z",
    transform: "translate(-62.287 -238.164)",
    fill: "#003975"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun-link-5923048",
    transform: "translate(54.948 42.804) rotate(45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.404 -1.404)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54078",
    "data-name": "Path 54078",
    d: "M6.188,13.082a6.168,6.168,0,0,0,4.374-1.809l2.3-2.3a.767.767,0,1,0-1.084-1.084l-2.3,2.3A4.653,4.653,0,1,1,2.9,3.608l2.3-2.3A.767.767,0,1,0,4.113.225l-2.3,2.3A6.184,6.184,0,0,0,6.188,13.082Z",
    transform: "translate(0 8.894)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54079",
    "data-name": "Path 54079",
    d: "M11.273,1.809a6.193,6.193,0,0,0-8.749,0l-2.3,2.3A.767.767,0,1,0,1.309,5.193l2.3-2.3a4.653,4.653,0,1,1,6.581,6.58l-2.3,2.3a.767.767,0,1,0,1.084,1.084l2.3-2.3a6.186,6.186,0,0,0,0-8.749Z",
    transform: "translate(8.897 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54080",
    "data-name": "Path 54080",
    d: "M.767,8.69a.763.763,0,0,0,.542-.225L8.466,1.309A.767.767,0,1,0,7.381.225L.225,7.381A.767.767,0,0,0,.767,8.69Z",
    transform: "translate(6.647 6.643)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.5
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_45819",
    "data-name": "Group 45819",
    transform: "translate(-0.015 4.898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-exclamation-2077915",
    transform: "translate(679.5 217.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_45818",
    "data-name": "Group 45818",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54228",
    "data-name": "Path 54228",
    d: "M37.521,68.136c-.132-.241-.264-.48-.4-.719l-.679-1.239-.908-1.654-1.07-1.95L33.3,60.455q-.6-1.1-1.206-2.2l-1.174-2.137-1-1.823-.089-.162-.933-1.7c-.241-.438-.48-.876-.721-1.313-.147-.269-.294-.537-.443-.806a3.045,3.045,0,0,0-.6-.828,2.447,2.447,0,0,0-3.192-.075,2.8,2.8,0,0,0-.684.883c-.144.261-.286.522-.43.784-.236.433-.475.863-.711,1.3l-.925,1.684q-.541.989-1.085,1.975l-1.172,2.132q-.6,1.1-1.206,2.2-.582,1.063-1.167,2.124-.537.981-1.077,1.96-.451.836-.91,1.669l-.689,1.256-.408.744a2.739,2.739,0,0,0-.393,1.376,2.511,2.511,0,0,0,.667,1.639,2.445,2.445,0,0,0,1.644.761c.167.01.336,0,.5,0H35.484A2.441,2.441,0,0,0,37.9,69.614,2.581,2.581,0,0,0,37.521,68.136Z",
    transform: "translate(-12.619 -48.859)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54229",
    "data-name": "Path 54229",
    d: "M37.521,68.136c-.132-.241-.264-.48-.4-.719l-.679-1.239-.908-1.654-1.07-1.95L33.3,60.455q-.6-1.1-1.206-2.2l-1.174-2.137-1.09-1.985-.933-1.7c-.241-.438-.48-.876-.721-1.313-.147-.269-.294-.537-.443-.806a3.045,3.045,0,0,0-.6-.828,2.447,2.447,0,0,0-3.192-.075,2.8,2.8,0,0,0-.684.883c-.144.261-.286.522-.43.784-.236.433-.475.863-.711,1.3l-.925,1.684q-.541.989-1.085,1.975l-1.172,2.132q-.6,1.1-1.206,2.2-.582,1.063-1.167,2.124-.537.981-1.077,1.96-.451.836-.91,1.669l-.689,1.256-.408.744a2.739,2.739,0,0,0-.393,1.376,2.511,2.511,0,0,0,.667,1.639,2.445,2.445,0,0,0,1.644.761c.167.01.336,0,.5,0H35.484A2.441,2.441,0,0,0,37.9,69.614,2.581,2.581,0,0,0,37.521,68.136Z",
    transform: "translate(-13.083 -48.859)",
    fill: "#fff",
    stroke: "#003975",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-exclamation",
    "data-name": "Icon awesome-exclamation",
    d: "M4.691,9.628A1.783,1.783,0,1,1,2.908,7.845,1.785,1.785,0,0,1,4.691,9.628ZM1.331.562l.3,6.062a.535.535,0,0,0,.534.508H3.647a.535.535,0,0,0,.534-.508l.3-6.062A.535.535,0,0,0,3.95,0H1.866A.535.535,0,0,0,1.331.562Z",
    transform: "translate(9.966 8.299)",
    fill: "#003975",
    stroke: "#fff",
    strokeWidth: 1
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkExpiry);
export default __webpack_public_path__ + "static/media/LinkExpiry.98a8c85b969e6028d1fb86329b04e2e1.svg";
export { ForwardRef as ReactComponent };